import React from 'react'
import { useState } from 'react'
import {ReactComponent as XIcon} from '../assets/icons/cancel.svg'

const Download = () => {
  const [hidden, setHidden] = useState(false);

  const onClick = () => {
    window.open(`http://Hamrahyper.ir/homepage#downloadSection`, '_blank');
  }

  const close = (e) => {
    e.stopPropagation();
    setHidden(true);
  }

  return (
    <div className={`w-full flex justify-between items-center p-2 px-2 cursor-pointer ${hidden ? 'hidden' : ''}`} style={{backgroundColor: '#88B711',direction: 'rtl'}} onClick={onClick}>
      <span className='mx-auto text-white font-bold'>برای دانلود اپلیکیشن 
      <strong className='asdf'> همراهایپر </strong>
       کلیک کنید</span>
      <span></span>
      <XIcon className='cursor-pointer' onClick={close} />
    </div>
  )
}

export default Download